/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowFamilyArtDayTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowFamilyArtDay,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Create Art Together!",
    "Family Art Day Awaits!",
    "Fun with Creativity for Everyone!",
  ],
  title: "Family Art Day",
  description: "Organize a fun family art day.",
  longDescription:
    "Gather your family for an exciting art day! Choose a date, decide on projects to create, and plan materials!",
  emoji: "🎨",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Family Art Day",
          emoji: "🎨",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the family art day?",
          emoji: "📅",
          completeAction: {
            question: "Decide on projects to create?",
            description: "What projects should we focus on during the day?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What projects should we consider?",
                emoji: "🖌",
                completeAction: {
                  question: "Decide on materials needed?",
                  description: "What materials should we gather for crafting?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What materials should we bring?",
                      emoji: "✂",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get Creative Together!",
    outroDescription:
      "Your family art day plans are set! Enjoy the creativity!",
  },
};
